import { pending } from '@/mocks/gossipData';

const tagStyle: Record<string, string> = {
  待认领: 'bg-accent-100 text-accent-800',
  在蹲: 'bg-primary-100 text-primary-800',
  围观: 'bg-secondary-100 text-secondary-800',
};

export default function PendingAlert() {
  return (
    <section id="pending" className="bg-background-50">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
              <i className="ri-time-line" />
              待爆预警
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              蹲一个 · 提前占好位置
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              风声已起但正主还没出面，先给你摆好线索，坐等黑吃瓜猛料落地。
            </p>
          </div>
          <a href="#pending" className="text-xs text-foreground-500 hover:text-primary-700 cursor-pointer whitespace-nowrap">
            订阅提醒（演示）→
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-3">
          {pending.map((p, i) => (
            <article
              key={p.title}
              className="fade-up group flex flex-col rounded-2xl border border-background-200 bg-white p-5 transition-colors hover:border-accent-300 md:p-6"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <div className="flex items-center justify-between">
                <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <i className="ri-eye-line text-accent-600" />
                  已有风闻
                </span>
                <span className={`rounded-md px-2 py-0.5 text-[10px] font-semibold ${tagStyle[p.tag]}`}>
                  {p.tag}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                {p.title}
              </h3>
              <p className="mt-2 flex items-start gap-1.5 text-sm text-foreground-600">
                <i className="ri-question-line mt-0.5 shrink-0 text-secondary-500" />
                {p.clue}
              </p>
              <div className="mt-5 flex items-center gap-2 border-t border-background-100 pt-4 text-xs">
                <span className="rounded-full bg-background-100 px-2.5 py-1 font-semibold text-foreground-700">
                  {p.eta}
                </span>
                <span className="text-foreground-400">落定后自动并入速递大卡</span>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2 rounded-2xl border border-dashed border-background-300 bg-background-100 px-4 py-4 text-center">
          <i className="ri-message-3-line text-primary-600" />
          <span className="text-sm text-foreground-600">
            追更节奏太快的朋友，可以用右上角圈子入口条挑一个喜欢的瓜田慢慢吃。
          </span>
        </div>
      </div>
    </section>
  );
}